import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoResource } from '@pit/frontend-model';
import { DtoResourceStoreFactory } from './dto.resource.store.factory';
import { IDtoResourceEntityDataService } from '../../module.data/services/interfaces/dto.resource.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceStoreFacade extends EntityStoreFacade<IDtoResource> {

    constructor(store: Store<IDtoResource>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoResourceStoreFactory.instance, store, 'DtoResource', dataServiceAccessor, eventService);
    }

    public getDevicesSorted$(): Observable<IDtoResource[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.resources'));
    }

    public async getDevicesSortedAsync(): Promise<IDtoResource[]> {
        let result: IDtoResource[] = [];
        try {
            result = await this.getDevicesSorted$().pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public loadResourcesForMandatorByDepot$(mandator: string, numberDepot: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.depot')({ mandator: mandator, numberDepot: numberDepot }));
    }

    public async loadResourcesForMandatorByDepotAsync(mandator: string, numberDepot: string): Promise<IDtoResource[]> {
        let result: IDtoResource[] = null;
        try {
            const queryResult: IDtoResource[] = await (this.dataServiceAccessor.getEntityDataService<IDtoResource>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoResourceEntityDataService).getResourcesForMandatorByDepotNumberAsync(mandator, numberDepot);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

}
